let homeStatisticsSwiper;
var init = false;

function enableSwiper(){
	homeStatisticsSwiper = new Swiper(".home-statistics .swiper", {
		// Optional parameters
		loop: true,
		slidesPerView: 1,
		lazy: true,
		simulateTouch: false,

		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
			pauseOnMouseEnter: true,
		},

		// If we need pagination
		pagination: {
			el: ".home-statistics .swiper .swiper-pagination",
			clickable: true,
		},

		// Navigation arrows
		navigation: false,

		breakpoints: {
			768: {
				slidesPerView: 2,
				slidesPerGroup: 2,
				spaceBetween: 30
			},
		}
	});
}


function swiperMode() {
	let mobile = window.matchMedia("(min-width: 0px) and (max-width: 767px)");
	let tablet = window.matchMedia("(min-width: 768px) and (max-width: 1199px)");
	let desktop = window.matchMedia("(min-width: 1200px)");

	// Enable (for mobile and tablet)
	if (mobile.matches || tablet.matches) {
		if (!init) {
			enableSwiper();
			init = true;
		}
	}

	// Disable (for desktop)
	else if (desktop.matches) {
		if(init){
			homeStatisticsSwiper.destroy();
			init = false;
		}
	}
}

window.addEventListener("load", function () {
	swiperMode();
});

window.addEventListener("resize", function () {
	swiperMode();
});